import { render, staticRenderFns } from "./orgRelStaff.vue?vue&type=template&id=32fdc72c&scoped=true"
import script from "./orgRelStaff.vue?vue&type=script&lang=js"
export * from "./orgRelStaff.vue?vue&type=script&lang=js"
import style0 from "./orgRelStaff.vue?vue&type=style&index=0&id=32fdc72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fdc72c",
  null
  
)

export default component.exports